import React from "react"
import { Container, Row, Col } from "reactstrap"
import { PROJECT_HANDLE } from "Apps"
const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col sm={6}>
              {PROJECT_HANDLE} Version <strong>2.5</strong> 
            </Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                {new Date().getFullYear()} © Iotera Team.
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
